import { render, staticRenderFns } from "./DashboardViewEditingFiltersCreateRule.vue?vue&type=template&id=0d7bfea4"
import script from "./DashboardViewEditingFiltersCreateRule.vue?vue&type=script&lang=js"
export * from "./DashboardViewEditingFiltersCreateRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports